import { DocumentWriteAction } from 'ag-common-lib/lib/lists/change-logs/document-write-actions.enum';
import { ChangeSourceType } from 'ag-common-lib/lib/lists/change-logs/change-source-type.enum';

export enum LoggedCollections {
  agent = 'agent',
  agentEmailAddress = 'agentEmailAddress',
  agentAssociations = 'agentAssociations',
  registrant = 'registrant',
  registrantGuest = 'registrantGuest',
  userAgreement = 'userAgreement',
  policySigners = 'policySigners',
}

export interface DocumentLog {
  collection: LoggedCollections;
  action: DocumentWriteAction;
  wasabiPath: string;
  date: string;
  updatedBy: string;
  updatedFields?: string[];
  changedBySource?: ChangeSourceType;
  documentIds: {
    [key: string]: string;
  };
}
